define.alias("shared/errors/unknown-route", "settings/errors/unknown-route");